import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services';

import {
  CreatePlanParams,
  CreatePlanResponse,
  GetAppliedPlansParams,
  GetAppliedPlansResponse,
  GetFilteredPlansParams,
  GetFilteredPlansResponse,
  GetMnoSubscriptionsParams,
  GetMnoSubscriptionsResponse,
  GetPlanResponse,
  TerminatePlanResponse,
  UpdatePlanParams,
  UpdatePlanResponse,
} from '../dtos';

@Injectable({
  providedIn: 'root',
})
export class PlansService {
  constructor(private readonly apiService: ApiService) {}

  /**
   * Get Plans
   * permissions: {mode: "+r", res: "plan.*"}
   * @param getFilteredPlansParams
   */
   getFilteredPlansInternal(getFilteredPlansParams: GetFilteredPlansParams): Observable<GetFilteredPlansResponse> {
    let params = this.apiService.queryParams(getFilteredPlansParams);
    return this.apiService.get('/v2-internal/plans', params);
  }

  /**
   * Get list of applied plans
   * @param getAppliedPlansParams applied plans req parameters
   */
  getAppliedPlans(
    getAppliedPlansParams: GetAppliedPlansParams
  ): Observable<GetAppliedPlansResponse> {
    let params = new HttpParams();

    Object.keys(getAppliedPlansParams).forEach((param) => {
      if (param !== 'consumerIdentityUuid') {
        params = params.append(param, getAppliedPlansParams[param]);
      }
    });

    return this.apiService.get(
      `/v1/consumers/identity/${getAppliedPlansParams.consumerIdentityUuid}/applied-plans`,
      params
    );
  }

  /**
   * permissions: {mode: "+c", res: "plan.*"}
   * @param createPlanParams
   * @returns
   */
  createPlan(createPlanParams: CreatePlanParams): Observable<CreatePlanResponse> {
    return this.apiService.post(
      '/v2-internal/plans/plan',
      createPlanParams
    );
  }

  getPlan(planId: string): Observable<GetPlanResponse> {
    return this.apiService.get(`/v2-internal/plans/plan/${planId}`);
  }

  /**
   * permissions: {mode: "+u", res: "plan.*"}
   * @param planUuid
   * @param updatePlanParams
   * @returns
   */
  updatePlan(
    planUuid: string, updatePlanParams: UpdatePlanParams
  ): Observable<UpdatePlanResponse> {
    return this.apiService.put(
      `/v2-internal/plans/plan/${planUuid}`,
      updatePlanParams
    );
  }

  terminatePlan(planId: string): Observable<TerminatePlanResponse> {
    return this.apiService.delete(`/v2-internal/plans/${planId}`);
  }

  /**
   * permissions: {mode: "+r", res: "mnoSubscription.*"}
   * @param getMnoSubscriptionsParams
   */
  getMnoSubscriptions(
    getMnoSubscriptionsParams?: GetMnoSubscriptionsParams
  ): Observable<GetMnoSubscriptionsResponse> {
    return this.apiService.get('/v1/plans/mno-subscription');
  }

}
